import { defineAsyncComponent } from "vue";

export default (app) => {
  /* ATOMS
   -------------------------------------------------------------*/

  /* MOLECULES
   -------------------------------------------------------------*/

  app.component(
    "M4AceEditor",
    defineAsyncComponent(() =>
      import(
        /* webpackChunkName: "ace-editor" */
        "./components/molecules/ace-editor/ace-editor.vue"
      )
    )
  );

  app.component(
    "M4DatetimePicker",
    defineAsyncComponent(() =>
      import(
        /* webpackChunkName: "datetime-picker" */
        "./components/molecules/datetime-picker/datetime-picker.vue"
      )
    )
  );

  /* ORGANISMS
   -------------------------------------------------------------*/
  app.component(
    "M4ActivitylogChanges",
    defineAsyncComponent(() =>
      import(
        /* webpackChunkName: "activitylog-changes" */
        "./components/organisms/activitylog-changes/activitylog-changes.vue"
      )
    )
  );

  app.component(
    "M4ColumnChooser",
    defineAsyncComponent(() =>
      import(
        /* webpackChunkName: "column-chooser" */
        "./components/organisms/column-chooser/column-chooser.vue"
      )
    )
  );

  app.component(
    "M4JsonCompare",
    defineAsyncComponent(() =>
      import(
        /* webpackChunkName: "json-compare" */
        "./components/organisms/json-compare/json-compare.vue"
      )
    )
  );
};
